export const spellCorrectionEvent = (event, {originalQuery, alteredQuery, uuid} = {}) => ({
  event,
  originalQuery,
  alteredQuery,
  uuid,
});

export const doNotSellShareEvent = () => (
  {
    event: 'doNotSellShare',
    opt_out: true
  }
);

export const productImpressionsEvent = (q, currency, designs, userId, itemListName) => (
  {
    ecommerce: {
      item_list_name: itemListName,
      currencyCode: currency,
      userId,
      actionField: {
        totalQuantity: designs?.length
      },
      search_term: q,
      impressions: designs
    }
  }
);

export const searchFilterChangedEvent = (searchParams, productImpressions) => {
  const nonEmptyFields = Object.keys(searchParams).reduce((filledFields, key) => {
    if (searchParams[key] || searchParams[key] === 0) {
      filledFields[key] = searchParams[key];
    }

    return filledFields;
  }, {});

  return {
    event: 'searchFilterClick',
    ...nonEmptyFields,
    ...productImpressions
  };
};
